import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { ContentLayout } from '../../../../components/ContentLayout';
import { PhoneAuthForm } from '../../../../components/PhoneAuthForm';
import { trackChangeLoginFlowTo, trackPhoneAuthResumeButtonClick } from '../../../../utils/tracking';
import { isPhone } from '../../../../utils/validation';
import { hasPhoneErrorSelector, isAutosubmitEnabled as isAutosubmitEnabledSelector, isPhoneAuthFormSubmitting, isPhoneInvalidSelector, phoneErrorSelector, phoneSelector } from './selectors';
import { selectAutoFocusDisabled } from '../../../../selectors/autoFocusDisabled';
import { changePhone, toggleAutosubmit } from '../../../../actions/phoneAuth';
import { checkPhone } from '../../../../actions/phoneAuth/checkPhone';
import { resetToUsernameAuth } from '../../../../actions/state';
export var FormContainer = function FormContainer(_ref) {
  var useSelector = _ref.useSelector,
    useDispatch = _ref.useDispatch;
  var dispatch = useDispatch();
  var isSubmitting = useSelector(isPhoneAuthFormSubmitting);
  var isAutosubmitEnabled = useSelector(isAutosubmitEnabledSelector);
  var phone = useSelector(phoneSelector);
  var hasAsyncPhoneError = useSelector(hasPhoneErrorSelector);
  var isPhoneInvalid = useSelector(isPhoneInvalidSelector);
  var phoneError = useSelector(phoneErrorSelector);
  var autoFocusDisabled = useSelector(selectAutoFocusDisabled);

  // FORM
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    changed = _React$useState2[0],
    setChanged = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    touched = _React$useState4[0],
    setTouched = _React$useState4[1];
  // PHONE
  var phoneRef = React.useRef(null);
  var handleChangePhone = React.useCallback(function (value) {
    var newValue = value.replace(/\s/gi, '');
    dispatch(changePhone(newValue));
    setChanged(true);
  }, [dispatch]);
  var switchView = React.useCallback(function () {
    trackChangeLoginFlowTo('email');
    dispatch(resetToUsernameAuth());
  }, [dispatch]);
  var handleSubmit = React.useCallback(function () {
    setTouched(true);
    trackPhoneAuthResumeButtonClick();
    if (isPhoneInvalid) {
      if (phoneRef.current) {
        phoneRef.current.focus();
      }
    }
    dispatch(checkPhone());
    setChanged(false);
  }, [dispatch, isPhoneInvalid]);
  React.useEffect(function () {
    if (isPhone(phone) && isAutosubmitEnabled) {
      handleSubmit();
      dispatch(toggleAutosubmit(false));
    }
  }, [dispatch, phone, isAutosubmitEnabled, handleSubmit]);
  return /*#__PURE__*/React.createElement(ContentLayout, null, /*#__PURE__*/React.createElement(PhoneAuthForm, {
    autoFocusDisabled: autoFocusDisabled,
    phoneRef: phoneRef,
    handleSubmit: handleSubmit,
    isSubmitting: isSubmitting,
    phone: phone,
    onPhoneChange: handleChangePhone,
    phoneError: !changed && phoneError || undefined,
    isPhoneInvalid: touched && (isPhoneInvalid || !changed && hasAsyncPhoneError),
    onSwitchAuthType: switchView
  }));
};